const convertCamelToSpaceString = (text: string): string => {
  const result = text.replaceAll(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export default convertCamelToSpaceString;
